import { createAction, props } from '@ngrx/store';
import { Partner, PartnerDetails, PartnerLocation, PartnerCategory, PagedPartners } from '../../models/partners.model';

export const loadAllPartners = createAction(
  '[Partner] Load All Partners',
  props<{ page: number, limit: number, query?: string }>()
);
export const loadAllPartnersSuccess = createAction(
  '[Partner] Load All Partners Success',
  props<{ partners: PagedPartners }>()
);

export const loadAllPartnersFailure = createAction(
  '[Partner] Load All Partners Failure',
  props<{ error: any }>()
);

export const searchPartners = createAction(
  '[Partner] Search Partners',
  props<{ page: number, limit: number, query: string }>()
);

export const searchPartnersSuccess = createAction(
  '[Partner] Search Partners Success',
  props<{ partners: PagedPartners }>()
);

export const searchPartnersFailure = createAction(
  '[Partner] Search Partners Failure',
  props<{ error: any }>()
);

export const loadCategories = createAction(
  '[Partner] Load Categories'
);

export const loadCategoriesSuccess = createAction(
  '[Partner] Load Categories Success',
  props<{ categories: PartnerCategory[] }>()
);

export const loadCategoriesFailure = createAction(
  '[Partner] Load Categories Failure',
  props<{ error: any }>()
);

export const loadPartners = createAction(
  '[Partner] Load Partners',
  props<{ page: number, limit: number, query: string }>()
);

export const loadPartnersSuccess = createAction(
  '[Partner] Load Partners Success',
  props<{ partners: PagedPartners }>()
);

export const loadPartnersFailure = createAction(
  '[Partner] Load Partners Failure',
  props<{ error: any }>()
);

export const updatePartner = createAction(
  '[Partner] Update Partner',
  props<{ partner: Partner }>()
);

export const createPartner = createAction(
  '[Partner] Create Partner',
);

export const createPartnerSuccess = createAction(
  '[Partner] Create Partner Success',
  props<{ partner: Partner }>()
);

export const createPartnerFailure = createAction(
  '[Partner] Create Partner Failure',
  props<{ error: string }>()
);

export const editPartner = createAction(
  '[Partner] Edit Partner',
  props<{ id: number }>()
);

export const editPartnerSuccess = createAction(
  '[Partner] Edit Partner Success',
  props<{ partner: Partner }>()
);


export const editPartnerFailure = createAction(
  '[Partner] Edit Partner Failure',
  props<{ error: string }>()
);

//partner details
export const loadPartner = createAction(
  '[Partner] Load Partner Details',
  props<{ id: number }>()
);

export const loadPartnerSuccess = createAction(
  '[Partner] Load Partner Details Success',
  props<{ partnerDetails: PartnerDetails }>()
  );

export const loadPartnerFailure = createAction(
  '[Partner] Load Partner Details Failure',
  props<{ error: any }>()
);

export const addLocation = createAction(
  '[Partner] Add Location'
);

export const addLocationSuccess = createAction(
  '[Partner] Add Location Success',
  props<{ location: PartnerLocation }>()
);

export const addLocationFailure = createAction(
  '[Partner] Add Location Failure',
  props<{ error: any }>()
);

export const updateLocation = createAction(
  '[Partner] Update Location',
  props<{ location: PartnerLocation }>()
);

export const uploadLocations = createAction(
  '[Partner] Upload Locations',
  props<{ locations: PartnerLocation[] }>()
);

export const editLocation = createAction(
  '[Partner] Edit Location',
  props<{ id: number }>()
);

export const editLocationSuccess = createAction(
  '[Partner] Edit Location Success',
  props<{ location: PartnerLocation }>()
);

export const editLocationFailure = createAction(
  '[Partner] Edit Location Failure',
  props<{ error: string }>()
);

export const loadLocations = createAction(
  '[Partner] Load Locations',
  props<{ partnerId: number }>()
);

export const locationsLoaded = createAction(
  '[Partner] Locations Loaded',
  props<{ locations: PartnerLocation[] }>()
);

export const loadLocationsFailure = createAction(
  '[Partner] Load Locations Failure',
  props<{ error: any }>()
);

export const disablePartner = createAction(
  '[Partner] Disable Partner',
  props<{ id: number }>()
);

export const disablePartnerSuccess = createAction(
  '[Partner] Disable Partner Success',
  props<{ partner: Partner }>()
);

export const disablePartnerFailure = createAction(
  '[Partner] Disable Partner Failure',
  props<{ error: any }>()
);



export const clearPartnerDetails = createAction('[Partner] Clear Partner Details');


//nuevo
export const selectPartner = createAction(
  '[Partner] Select Partner',
  props<{ partner_id: number }>()
);

export const selectPartnerSuccess = createAction(
  '[Partner] Select Partner Success',
  props<{ partner: Partner }>()
);

export const selectPartnerFailure = createAction(
  '[Partner] Select Partner Failure',
  props<{ error: any }>()
);

export const showPartnerAlertDialog = createAction(
  '[Partner] Show Partner Alert Dialog',
  props<{ partner: Partner }>()
);


